export default "__VITE_PUBLIC_ASSET__599b4283__"